/**
 * CandidatureContext — Profil candidat uniquement (porté de CandidatureContext.tsx)
 * Le suivi des candidatures est désormais géré exclusivement par AppStore.
 */
import { Injectable, computed, signal } from '@angular/core';
import type { CandidatureProfile } from './candidature';

/** Type Application exposé pour compatibilité avec les composants existants */
export interface Application {
  propertyId: number;
  propertyTitle: string;
  propertyLocation: string;
  propertyPrice: number;
  propertyImage: string;
  propertyType: string;
  submittedAt: string;   // date formatée ou ISO
  status: 'pending' | 'viewed' | 'accepted' | 'rejected';
}

@Injectable({ providedIn: 'root' })
export class CandidatureContextService {
  readonly profile = signal<CandidatureProfile | null>(null);
  readonly hasProfile = computed(() => this.profile() !== null);

  saveProfile(p: CandidatureProfile) {
    this.profile.set(p);
  }

  clearProfile() {
    this.profile.set(null);
  }
}
